import { isProdLike } from './isProdLike';

export const __DEV__ = isProdLike === false;

export function log(...args) {
  if (__DEV__) {
    console.log(...args);
  }
}
